export default "__VITE_ASSET__ca34d9b9__"